export enum CHIP_DISCOUNT_COLOR {
    ORANGE = 'orange',
    GREEN = 'green',
    STRONG_GREEN = 'strong-green',
    DISABLED = 'disabled'
}